/* eslint-disable no-console */
import { DatePicker, Popover } from "antd";
import React, { useState } from "react";
import TickIcon from "../../../Common/Svgs/TickIcon";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import { TOTAL_PAID_FILTER } from "./data";

const options = [
  {
    id: TOTAL_PAID_FILTER.ALL_TIME,
    value: "All Time",
  },
  {
    id: TOTAL_PAID_FILTER.LAST_WEEK,
    value: "Last Week",
  },
  {
    id: TOTAL_PAID_FILTER.LAST_MONTH,
    value: "Last Month",
  },
  {
    id: TOTAL_PAID_FILTER.LAST_3_MONTHS,
    value: "Last 3 Months",
  },
  {
    id: TOTAL_PAID_FILTER.LAST_6_MONTHS,
    value: "Last 6 Months",
  },
  {
    id: TOTAL_PAID_FILTER.LAST_YEAR,
    value: "Last Year",
  },
  {
    id: TOTAL_PAID_FILTER.CUSTOM,
    value: "Custom",
  },
];

const KpiTimeFilter = ({ currentFilter, setCurrentFilter }) => {
  const [open, setOpen] = useState(false);
  const [dateRangeOpen, setDateRangeOpen] = useState(false);
  const [datePanelRangeOpen, setDatePanelRangeOpen] = useState(false);

  console.log(dateRangeOpen, datePanelRangeOpen);

  const onDateRangeSelect = (e) => {
    if (e.length < 2) return;

    setCurrentFilter((prev) => ({
      ...prev,
      custom: e,
    }));

    setDatePanelRangeOpen(false);
    setDateRangeOpen(false);
    setOpen(false);
  };

  const getBody = (option, selected) => {
    if (option.id === TOTAL_PAID_FILTER.CUSTOM && selected) {
      return (
        <div className="px-3">
          {/* close the date picker if no values selected */}
          <div
            className="fixed top-0 bottom-0 right-0 left-0 w-full h-full bg-transparent"
            onClick={() => {
              setOpen(false);
              setDateRangeOpen(false);
              setDatePanelRangeOpen(false);
              setCurrentFilter({
                id: 1,
                value: "all time",
                custom: [],
              });
            }}
          />

          <DatePicker.RangePicker
            // open={datePanelRangeOpen}
            format="DD, MMM YYYY"
            value={currentFilter?.custom?.length ? currentFilter.custom : null}
            placement="bottom"
            separator="-"
            allowClear={false}
            className="h-[30px] max-w-[245px] z-10 font-poppins"
            inputReadOnly
            onChange={onDateRangeSelect}
            onOpenChange={(state) => setDatePanelRangeOpen(state)}
          />
        </div>
      );
    }

    return (
      <button
        type="button"
        key={option.id}
        className="w-full py-2 px-3 capitalize group hover:bg-background max-h-20"
        onClick={() => {
          setCurrentFilter({ ...option, custom: [] });

          if (option.id === TOTAL_PAID_FILTER.CUSTOM) {
            setDateRangeOpen(true);
          } else {
            setOpen(false);
          }
        }}
      >
        <div className="flex items-center justify-between">
          <p
            className={`font-aileron text-xs font-semibold text-left
              ${
                selected
                  ? "text-black"
                  : "text-dark-gray group-hover:text-black"
              }
             `}
          >
            {option.value}
          </p>

          {selected ? (
            <div className="flex items-center gap-x-2">
              <TickIcon size={16} strokeWidth={2} className="text-primary" />
            </div>
          ) : null}
        </div>
      </button>
    );
  };

  return (
    <div className="relative">
      <Popover
        trigger="click"
        placement="bottomLeft"
        open={open}
        arrow={false}
        onOpenChange={(state) => setOpen(state)}
        content={
          <div
            className="bg-background-white rounded-md py-1"
            style={{ width: "252px" }}
            // style={{
            //   width: dateRangeOpen ? "245px" : "180px",
            // }}
          >
            {options.map((option) => {
              const selected = currentFilter.id === option.id;
              return <div key={option.id}>{getBody(option, selected)}</div>;
            })}
          </div>
        }
      >
        <div
          role="button"
          className="px-3.5 py-2 w-[180px] flex items-center justify-end gap-x-2"
        >
          <p className="font-poppins font-medium text-xs capitalize text-green whitespace-nowrap">
            {currentFilter?.value}
          </p>

          <ChevronIcon
            strokeWidth="1"
            className={`w-4 h-4 stroke-green transform transition-all duration-200 ${
              open ? "-rotate-90" : "rotate-90"
            }`}
          />
        </div>
      </Popover>
    </div>
  );
};

export default KpiTimeFilter;
